import { lazy } from 'react';
import { createBrowserRouter } from 'react-router-dom';

import ProtectedAdminRoute from '@/router/protected-admin-route';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function lazyWithRetry(dynamicImportFn: () => any) {
  return lazy(() =>
    dynamicImportFn().catch((e: unknown) => {
      console.error('ROUTER ERROR', e);
      return import('@/pages/error');
    }),
  );
}

export const routes = {
  root: '/',
  event: '/market/:id',
  referral: '/referral',
  blocked: '/blocked',
  profile: '/profile',
  leaderboard: '/leaderboard',
  profileId: '/profile/:id',
  recentVotes: '/recent-votes',
  recentVotesId: '/recent-votes/:id',
  admin: {
    login: '/admin/login',
    dashboard: '/admin/dashboard',
    fee: '/admin/fee',
    leaderboard: '/admin/leaderboard',
    votes: '/admin/votes',
    newEvent: '/admin/new-event',
    editEvent: '/admin/edit-event/:id',
    settings: '/admin/settings',
  },
} as const;

// Define lazy route components
const DefaultLayout = lazyWithRetry(
  () => import('@/components/layouts/default-layout'),
);

const MainPage = lazyWithRetry(() => import('@/pages/main'));
const EventPage = lazyWithRetry(() => import('@/pages/event'));
const RecentVotesPage = lazyWithRetry(() => import('@/pages/recent-votes'));
const ReferralPage = lazyWithRetry(() => import('@/pages/referral'));
const NotFoundPage = lazyWithRetry(() => import('@/pages/not-found'));
const DashboardPage = lazyWithRetry(() => import('@/pages/admin/dashboard'));
const AdminLoginPage = lazyWithRetry(() => import('@/pages/admin/login'));
const NewMarketPage = lazyWithRetry(() => import('@/pages/admin/new-market'));
const EditMarketPage = lazyWithRetry(() => import('@/pages/admin/edit-market'));
const FeePage = lazyWithRetry(() => import('@/pages/admin/fee'));
const ProfilePage = lazyWithRetry(() => import('@/pages/profile'));
const LeaderboardPage = lazyWithRetry(
  () => import('@/pages/admin/leaderboard'),
);
const VotesPage = lazyWithRetry(() => import('@/pages/admin/votes'));
const BlockedPage = lazyWithRetry(() => import('@/pages/blocked'));
const LeaderboardUserPage = lazyWithRetry(() => import('@/pages/leaderboard'));
const SettingsPage = lazyWithRetry(() => import('@/pages/admin/settings'));

export const router = createBrowserRouter([
  {
    path: routes.root,
    Component: DefaultLayout,
    children: [
      {
        path: routes.root,
        Component: MainPage,
      },
      {
        path: routes.event,
        Component: EventPage,
      },
      {
        path: routes.referral,
        Component: ReferralPage,
      },
      {
        path: routes.leaderboard,
        Component: LeaderboardUserPage,
      },
      {
        path: routes.root,
        element: <ProtectedAdminRoute />,
        children: [
          {
            path: routes.admin.dashboard,
            Component: DashboardPage,
          },
          {
            path: routes.admin.newEvent,
            Component: NewMarketPage,
          },
          {
            path: routes.admin.editEvent,
            Component: EditMarketPage,
          },
          {
            path: routes.admin.fee,
            Component: FeePage,
          },
          {
            path: routes.admin.leaderboard,
            Component: LeaderboardPage,
          },
          {
            path: routes.admin.votes,
            Component: VotesPage,
          },
          {
            path: routes.admin.login,
            Component: AdminLoginPage,
          },
          {
            path: routes.admin.settings,
            Component: SettingsPage,
          },
          {
            path: routes.profile,
            Component: ProfilePage,
          },
          {
            path: routes.profileId,
            Component: ProfilePage,
          },
          {
            path: routes.recentVotes,
            Component: RecentVotesPage,
          },
          {
            path: routes.recentVotesId,
            Component: RecentVotesPage,
          },
        ],
      },
      {
        path: '*',
        Component: NotFoundPage,
      },
    ],
  },
  {
    path: routes.blocked,
    Component: BlockedPage,
  },
]);
